<script>
import { Bar } from 'vue-chartjs'
import { mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-vars
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  extends: Bar,
  props: {
    dataType: {
      type: String,
      default() {
        return ''
      }
    },
    labels: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters({
      studentsToPartnersForYear: 'statistics/getStatsStudentsToPartners',
      countSchoolsDOClasses: 'statistics/getStatsCountSchoolsDOClasses',
      orgs: 'dicts/getOrganizations'
    })
  },
  methods: {
    getDataset(data) {
      if (!data) {
        return []
      }
      return this.labels.map((year) => data[year])
    }
  },
  mounted() {
    const stats = {}
    if (this.dataType === 'studentsToPartners') {
      for (let i = 0; i < this.labels.length; i++) {
        stats[this.labels[i]] = this.studentsToPartnersForYear
          .find((p) => p.year === this.labels[i]).count
      }
    } else if (this.dataType === 'countSchools') {
      for (let i = 0; i < this.labels.length; i++) {
        stats[this.labels[i]] = this.countSchoolsDOClasses
          .filter((p) => p.year === this.labels[i])[0].countSchools
      }
    } else if (this.dataType === 'countClasses') {
      for (let i = 0; i < this.labels.length; i++) {
        stats[this.labels[i]] = this.countSchoolsDOClasses
          .filter((p) => p.year === this.labels[i])[0].countClasses
      }
    } else if (this.dataType === 'countDO') {
      for (let i = 0; i < this.labels.length; i++) {
        stats[this.labels[i]] = this.countSchoolsDOClasses
          .filter((p) => p.year === this.labels[i])[0].countDO
      }
    }
    const datasets4 = [
      {
        backgroundColor: 'rgba(255,255,255,.3)',
        borderColor: 'transparent',
        data: this.getDataset(stats)
      }
    ]
    this.renderChart(
      {
        labels: this.labels.map((label) => {
          const backYear = Number(label) - 2000
          return this.dataType === 'studentsToPartners'
            ? label
            : `${backYear - 1}-${backYear}`
        }),
        datasets: datasets4
      },
      {
        tooltips: {
          callbacks: {
            title() {
              return ''
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              color: 'white'
            },
            ticks: {
              fontColor: 'white'
            },
            categoryPercentage: 1,
            barPercentage: 0.6
          }],
          yAxes: [{
            display: false,
            ticks: {
              beginAtZero: true
            }
          }]
        },
        plugins: {
          datalabels: {
            color: '#fff',
            formatter: (value) => value,
            clamp: true,
            align: 'end'
          }
        }
      },
    )
  }
}
</script>

<style scoped>

</style>
